import React from "react";
import About from "../components/About";
import Hero from "../components/Hero";
import Projects from "../components/Projects";

export default function Home() {
  return (
    <div className="bg-bg relative">
      <div className="blur-[300px] w-[500px] h-[500px] rounded-full bg-[#eeeeee50] absolute right-0 top-0"></div>
      <Hero />
      <Projects />
      <About />
    </div>
  );
}
